<template lang="html">
  <a
    ref="button"
    :href="href"
    class="job-ad__row job-ad__row--align-center"
    @click.prevent="openModal"
  >
    <button class="button button--primary button--bold job-ad__apply-button">{{ 'client.apply_button' | t }}</button>
  </a>
</template>

<script>
import ApplyModalContent from './apply_modal_content'
import EmailApplicationModal from './email_application_modal'

export default {
  props: {
    'applyEmail': {
      type: String,
      default: null
    },
    'jobId': {
      type: String,
      default: null
    },
    'jobTitle': {
      type: String,
      default: null
    },
    'jobEmployer': {
      type: String,
      default: null
    }
  },
  computed: {
    href () {
      return this.applyEmail ? '#job_application_form' : '#apply_modal'
    }
  },
  methods: {
    openModal () {
      EventBus.trigger('tracking:manualEventTrack', { action_type: 'apply', $elem: $(this.$refs.button) })
      if (this.applyEmail) {
        this.$store.commit('modalOpen', { component: EmailApplicationModal, props: this.$props })
      } else {
        this.$store.commit('modalOpen', { component: ApplyModalContent })
      }
    }
  }
}
</script>
